// Copyright ©️ 2026 eVolve MEP, LLC

import { type NumberInputProps, ComboboxClearButton, NumberInput } from '@mantine/core';

import { useUncontrolledNumber } from 'hooks/useUncontrolledNumber';

type Props = {
  value?: number | null;
  onChange: (value: number | null) => void;
  onSubmit?: () => void;
  clearable?: boolean;
};

export type NumberInputWrappedProps = Omit<NumberInputProps, keyof Props> & Props;

export const NumberInputWrapped = ({
  onSubmit,
  value,
  defaultValue,
  onChange,
  onBlur,
  onKeyDown,
  clearable,
  ...props
}: NumberInputWrappedProps) => (
  <NumberInput
    rightSection={clearable && !!value ? <ComboboxClearButton onClear={() => onChange(null)} /> : undefined}
    {...props}
    {...useUncontrolledNumber({
      value,
      defaultValue,
      onChange,
      onSubmit,
      onKeyDown,
      onBlur,
    })}
  />
);
